// extracted by mini-css-extract-plugin
export default {"root":"ConfirmUserRoleChange_root__+Qq93","sub-header":"ConfirmUserRoleChange_sub-header__WN7TY"};